/** Load the same Move typefaces when the embedding page has no application font stylesheet. */
export function installWidgetFonts(): HTMLLinkElement {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,400;0,600;1,400;1,600&family=Poppins:wght@700&display=swap';
  document.head.append(link);
  return link;
}
